module.exports = __webpack_public_path__ + "static/media/intro.51a15914.mp3";